

document.addEventListener('DOMContentLoaded', () => {
  // GLOBAL

  if (document.querySelectorAll('.LS-truncateContainer').length > 0) {
    document.querySelectorAll('.LS-truncateContainer').forEach((detail) => {
      let summary = detail.querySelector('.LS-truncate');
      let content = Array.from(detail.children).filter(child => child !== summary);
      content.forEach(el => { el.style.opacity = '0'; el.style.transition = 'opacity 0.5s linear'; });
      detail.addEventListener('toggle', function () {
        if (this.open) { content.forEach(el => el.style.opacity = '1'); } else { content.forEach(el => el.style.opacity = '0'); }
      });
    });
  }

  var lazySections = [].slice.call(document.querySelectorAll(".shopify-section")).filter(function (section) {
    return section.querySelector("video.lazy");
  });

  if ("IntersectionObserver" in window) {
    var lazySectionObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (section) {
        if (section.isIntersecting) {
          var videos = section.target.querySelectorAll("video.lazy");
          videos.forEach(function (video) {
            if (video.classList.contains('lazy')) {
              video.poster = video.dataset.poster;
              for (var source in video.children) {
                var videoSource = video.children[source];
                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                  videoSource.src = videoSource.dataset.src;
                }
              }
              video.load();
              video.classList.remove("lazy");
            } else {
              // video.play();
              // video.currentTime = 0;
              // video.style.opacity = '1';
            }
          });
          lazySectionObserver.unobserve(section.target);
        } else {
          // var videos = section.target.querySelectorAll("video");
          // videos.forEach(function (video) {
          //   video.pause();
          //   video.currentTime = 0;
          //   video.style.opacity = '0';
          // }); 
        }
      });
    });

    lazySections.forEach(function (lazySection) {
      lazySectionObserver.observe(lazySection);
    });
  }

  if (document.querySelectorAll('.coll_pro_new_season').length > 0) {
    document.querySelectorAll('.coll_pro_new_season').forEach((event) => {
      let SeasonInnerHtml = event.innerHTML;
      if (SeasonInnerHtml.includes('*')) { event.classList.add('hidden'); }
    });
  }
  if (document.querySelectorAll('.live_chat').length > 0) {
    document.querySelectorAll('.live_chat').forEach((elm) => {
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        // Gorgias is deferred to first interaction (gorgias-facade). Ensure it loads, then open.
        try {
          if (typeof window.loadGorgias === 'function') {
            window.loadGorgias(true);
          } else if (typeof GorgiasChat !== 'undefined' && GorgiasChat.open) {
            GorgiasChat.open();
          }
        } catch (e) {}
      });
    });
  }
  // Footer accordion — always open on desktop (> 1024), toggleable on mobile
  (function () {
    const BREAKPOINT = 1024;

    function getDetails() {
      return document.querySelectorAll('details.Footer__grid__item');
    }

    function applyState() {
      if (window.innerWidth > BREAKPOINT) {
        getDetails().forEach(el => { el.open = true; });
      }
    }

    function initSummaryListeners() {
      getDetails().forEach(el => {
        const summary = el.querySelector('summary');
        if (!summary || summary._footerBound) return;
        summary._footerBound = true;
        summary.addEventListener('click', e => {
          if (window.innerWidth > BREAKPOINT) e.preventDefault();
        });
      });
    }

    function init() {
      initSummaryListeners();
      applyState();
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyState, 150);
    });

    // Re-init when theme editor adds/removes footer blocks
    document.addEventListener('shopify:section:load', e => {
      if (e.target.closest('.FooterMainBlockSection')) init();
    });

    init();
  })();

  // Removed: legacy mega-navigation hover wiring (.MnObjNavMine,
  // .WpmegaMenuDetails, .InnerGrandChildElement, .OuterNavigationCollectionWp).
  // Replaced by the new mega menu in sections/header.liquid.
  // Legacy header behaviour removed during the May 2026 header rebuild.
  // The new header lives in sections/header.liquid and uses inline custom
  // elements (<sticky-header>, <header-nav>) for state. Swiper for the
  // promo bar is replaced by Dawn's <slideshow-component>.
  // Cart opener removed: the new <cart-drawer> (assets/cart-drawer.js) binds
  // #cart-icon-bubble itself and opens via the `cart:open` event.
  // document.addEventListener('click', function (event) {
  //   if (event.target.classList.contains('cv_login_account')) {
  //     event.preventDefault();
  //     var DetectHtml = event.target.getAttribute('href');
  //     document.querySelector('[snippets="popup-content-layout"]').classList.add('active');
  //     var popupHolderWrap = document.querySelector('.WrapperMainPopupExec__DX [js-popupHolderWrap]');
  //     popupHolderWrap.innerHTML = document.querySelector(DetectHtml).innerHTML;
  //     document.body.classList.add('PopupMasked');
  //   }
  // });
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('cv_recover_password')) {
      var recoverPasswordForms = document.querySelectorAll('.recover_password_form');
      recoverPasswordForms.forEach(function (form) { form.classList.toggle('hide'); });
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.classList.contains('hide_reset')) {
      var recoverPasswordForms = document.querySelectorAll('.recover_password_form');
      for (var i = 0; i < recoverPasswordForms.length; i++) {
        recoverPasswordForms[i].classList.add('hide');
      }
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    var cvPopCrossIconSvg = target.closest('.cv_pop_cross_icon svg');
    if (cvPopCrossIconSvg) {
      document.querySelectorAll('[snippets="popup-content-layout"]').forEach(function (element) {
        element.classList.remove('active');
      });
      document.body.classList.remove('PopupMasked');
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("cv_register_mobhead")) {
      event.target.classList.add('active');
      document.querySelectorAll(".mobile_loginform_outer").forEach(function (element) {
        element.classList.remove('active');
      });
      document.querySelectorAll(".mobile_register_from-outer").forEach(function (element) {
        element.classList.add('active');
      });
      document.querySelectorAll(".cv_login_mobhead").forEach(function (element) {
        element.classList.remove('active');
      });
    }
  });
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("cv_login_mobhead")) {
      event.target.classList.add('active');
      document.querySelectorAll(".mobile_loginform_outer").forEach(function (element) {
        element.classList.add('active');
      });
      document.querySelectorAll(".mobile_register_from-outer").forEach(function (element) {
        element.classList.remove('active');
      });
      document.querySelectorAll(".cv_register_mobhead ").forEach(function (element) {
        element.classList.remove('active');
      });
    }
  });

  if (window.innerWidth < 1025) {
    var scrollCount = 0, latestScrollTop = 0, doc = document.documentElement, top = 0;
    window.addEventListener('scroll', function () {
      top = (window.scrollY || doc.scrollTop) - (doc.clientTop || 0);
      if (latestScrollTop < top) { scrollCount += 1; } else { scrollCount -= 1; }
      latestScrollTop = top;
      if (latestScrollTop > 60) { document.querySelector('.section-header').classList.add('MakeItPermanent'); document.body.classList.add('stickyhd'); } else { document.querySelector('.section-header').classList.remove('MakeItPermanent'); document.body.classList.remove('stickyhd'); }
    });
  }
  var tabTarget = document.querySelectorAll('.accountLeftSectionList .cv_animation a');
  if (tabTarget)
    tabTarget.forEach(function (tab) {
      if (tab)
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var actionLink = this.getAttribute('href');
          tabTarget.forEach(function (link) { link.classList.remove('active'); })
          document.querySelectorAll('.accountRightSectionList .cv_account').forEach(function (item) { item.classList.remove('active'); });
          this.classList.add('active'); document.querySelector(actionLink).classList.add('active');
        })
    });
  var userAgent = window.navigator.userAgent;
  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) { document.body.classList.add('SafariBrowserObserver') }











  // HOMEPAGE

  if (document.querySelectorAll('.index-Mp-Video-Wrap').length > 0) {
    if (document.querySelectorAll('.desktopLayoutmpVideo > video').length > 0) {
      window.onload = function () {
        window.onscroll = (event) => {
          if (window.screen.width > 749) { document.querySelector('.desktopLayoutmpVideo video').paused ? document.querySelector('.desktopLayoutmpVideo video').play() : '' }
        }
      }
    }
    document.querySelector('[js-mpvideocontroller]').addEventListener('click', (evt) => {
      evt.target.closest('.mobileLayoutVideo').classList.add('active');
      let VideoSrc = evt.target.closest('.VideoWrapMn__DX').firstChild.getAttribute('cpvd');
      evt.target.closest('.VideoCoverImage__DxMb').children[2].innerHTML = VideoSrc;
    })
    document.querySelector('[js-mpvideocontroller-remove]').addEventListener('click', (evt) => {
      evt.target.closest('.mobileLayoutVideo').classList.remove('active');
      evt.target.closest('.VideoCoverImage__DxMb').children[2].innerHTML = '';
    })
  }


//   // PRODUCT PAGE

//   if (document.querySelectorAll('[fromprice]').length > 0) {
//     let FormPrice = document.querySelector('[fromprice]').getAttribute('fromprice');
//     let FormPriceButton = document.querySelector('[frompricebutton]').getAttribute('frompricebutton');
//     document.querySelector('.product__price__display').innerHTML = `${FormPrice}`;
//     document.querySelector('#product-form__buttons--price').innerHTML = `${FormPriceButton}`;
//   }
//   var MediaThumbnailView = new Swiper(
//     ".custom-desktop-gallery .swiper.slider-section__wrapper.Thumbnail",
//     {
//       slidesPerView: 11,
//       direction: "horizontal",
//       spaceBetween: 10,
//       loop: false,
//       watchSlidesProgress: true,
//       slideHeight: 200,
//       on: {
//         init: (swiper) => {
//           if (
//             document
//               .querySelector(
//                 ".custom-desktop-gallery .slider-section__wrapper.Thumbnail"
//               )
//               .querySelector(".custom-desktop-gallery .swiper-wrapper")
//               .childElementCount > 11
//           ) {
//             const swiperWrapper = document.querySelector(
//               ".custom-desktop-gallery .Thumbnail .swiper-wrapper"
//             );
//             if (swiperWrapper) {
//               swiperWrapper.style.justifyContent = "flex-start";
//             }
//             let totalGap =
//               swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//             totalGap = parseInt(totalGap + 45);
//             document.querySelector(
//               ".custom-desktop-gallery .swiper.slider-section__wrapper.Thumbnail"
//             ).style.height = 100 + "px";
//             window.addEventListener("resize", () => {
//               let totalGap =
//                 swiper.slides[0].clientHeight *
//                 swiper.passedParams.slidesPerView;
//               totalGap = parseInt(totalGap + 45);
//               document.querySelector(
//                 ".custom-desktop-gallery .swiper.slider-section__wrapper.Thumbnail"
//               ).style.height = 100 + "px";
//             });
//           } else {
//             // let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//             // totalGap = parseInt(totalGap + 65);
//             document.querySelector(
//               ".custom-desktop-gallery .swiper.slider-section__wrapper.Thumbnail"
//             ).style.height = 100 + "px";
//             window.addEventListener("resize", () => {
//               // let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//               // totalGap = parseInt(totalGap + 65);
//               document.querySelector(
//                 ".custom-desktop-gallery .swiper.slider-section__wrapper.Thumbnail"
//               ).style.height = 100 + "px";
//             });
//           }
//         },
//       },
//     }
//   );
//   var MediaMainProductView = new Swiper(
//     ".custom-desktop-gallery .swiper.slider-section__wrapper.MainImage",
//     {
//       autoHeight: true,
//       centeredSlides: false,
//       loop: false,
//       slidesPerView: 2,
//       spaceBetween: 15,
//       watchOverflow: true,
//       pagination: {
//         el: ".custom-desktop-gallery .swiper-pagination",
//       },
//       navigation: {
//         nextEl: ".custom-desktop-gallery .swiper-button-next",
//         prevEl: ".custom-desktop-gallery .swiper-button-prev",
//       },
//       // scrollbar: { el: '.swiper-scrollbar', draggable: true },
//       thumbs: { swiper: MediaThumbnailView },
//     }
//   );

//   var MediaMainProductViewMobile = new Swiper(
//     ".custom-mobile-gallery .swiper.slider-section__wrapper.MainImage",
//     {
//       autoHeight: true,
//       centeredSlides: false,
//       loop: false,
//       slidesPerView: 1,
//       spaceBetween: 15,
//       watchOverflow: true,
//       pagination: {
//         el: ".custom-mobile-gallery .swiper-pagination",
//       },
//       navigation: {
//         nextEl: ".custom-mobile-gallery .swiper-button-next",
//         prevEl: ".custom-mobile-gallery .swiper-button-prev",
//       },
//       scrollbar: { el: '.swiper-scrollbar', draggable: true },
//       // thumbs: { swiper: MediaThumbnailView },
//     }
//   );

//   function updateArrowVisibility(swiper) {
//     var prevArrow = document.querySelector('.custom-mobile-gallery .swiper-button-prev');
//     var nextArrow = document.querySelector('.custom-mobile-gallery .swiper-button-next');
//     if (!prevArrow || !nextArrow) return;
//     if (swiper.isBeginning) {
//       prevArrow.style.display = 'none';
//     } else {
//       prevArrow.style.display = 'flex';
//     }
//     if (swiper.isEnd) {
//       nextArrow.style.display = 'none';
//     } else {
//       nextArrow.style.display = 'flex';
//     }
//   }

//   MediaMainProductViewMobile.on('init', function() {
//     updateArrowVisibility(MediaMainProductViewMobile);
//   });
//   MediaMainProductViewMobile.on('slideChange', function() {
//     updateArrowVisibility(MediaMainProductViewMobile);
//   });
//   // If Swiper is already initialized, call once
//   if (MediaMainProductViewMobile.initialized) {
//     updateArrowVisibility(MediaMainProductViewMobile);
//   }

//   if (document.querySelectorAll('.product__accordion [name="country"]').length > 0) {
//     document.querySelectorAll('[name="country"]').forEach((input) => {
//       input.addEventListener('click', (elm) => {
//         document.querySelector('.country_ul_outer').classList.toggle('open_country');
//         document.querySelectorAll('[name="country"]').forEach((oninput) => {
//           oninput.closest('.country_li').classList.remove('active_li');
//         });
//         elm.target.checked ? elm.target.closest('.country_li').classList.add('active_li') : '';
//         let SelectedRegion = elm.target.value;
//         document.querySelectorAll('.shipping_product').forEach((shpresult) => {
//           shpresult.classList.contains(SelectedRegion)
//             ? shpresult.classList.remove('hide')
//             : shpresult.classList.add('hide');
//         });
//       });
//     });
//   }


//   if (document.querySelectorAll('.PopupInitiateWp').length > 0) {
//     document.querySelectorAll('.PopupInitiateWp').forEach((elm) => {
//       elm.addEventListener('click', (target) => {
//         target.preventDefault();
//         let Root_html = target.currentTarget.getAttribute('href');
//         document.body.classList.add('PopupIniatePdp');
//         Root_html.includes('contactform')
//           ? document.querySelector('[data-section-type="product-contact-form"]').classList.add('visibleLayout')
//           : '';
//       });
//     });
//     document.querySelectorAll('.cv_pop_cross_icon').forEach((elm) => {
//       elm.addEventListener('click', (target) => {
//         target.preventDefault();
//         document.body.classList.remove('PopupIniatePdp');
//         document.querySelector('[data-section-type="product-contact-form"]').classList.remove('visibleLayout');
//       });
//     });
//   }

//   if (document.querySelectorAll('.PopUpZoomPDP_Images').length > 0) {
//     document.querySelectorAll('.MainImage img').forEach((elm) => {
//       elm.addEventListener('click', (evt) => {
//         evt.preventDefault();
//         let CurrentPopupChoosed = evt.target.closest('.swiper-slide').getAttribute('mnmg');
//         CurrentPopupChoosed = parseInt(CurrentPopupChoosed) - parseInt(1);
//         document.body.classList.add('zoomPopupActive');
//         if (window.screen.width > 769) {
//           var Zoom$MediaThumbnailView = new Swiper('.swiper.Zoom_slider-section__wrapper.Zoom_Thumbnail', {
//             slidesPerView: 5,
//             direction: 'vertical',
//             spaceBetween: 10,
//             loop: false,
//             navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
//             watchSlidesProgress: true,
//             slideHeight: 200,
//             on: {
//               init: (swiper) => {
//                 if (
//                   document
//                     .querySelector('.Zoom_slider-section__wrapper.Zoom_Thumbnail')
//                     .querySelector('.swiper-wrapper').childElementCount > 5
//                 ) {
//                   let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                   totalGap = parseInt(totalGap + 45);
//                   document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_Thumbnail').style.height =
//                     totalGap + 'px';
//                   window.addEventListener('resize', () => {
//                     let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                     totalGap = parseInt(totalGap + 45);
//                     document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_Thumbnail').style.height =
//                       totalGap + 'px';
//                   });
//                 } else {
//                   let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                   totalGap = parseInt(totalGap + 65);
//                   document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_Thumbnail').style.height =
//                     totalGap + 'px';
//                   window.addEventListener('resize', () => {
//                     let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                     totalGap = parseInt(totalGap + 65);
//                     document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_Thumbnail').style.height =
//                       totalGap + 'px';
//                   });
//                 }
//               },
//             },
//           });
//           var Zoom$MediaMainProductView = new Swiper('.swiper.Zoom_slider-section__wrapper.Zoom_MainImage', {
//             zoom: { maxRatio: 2 },
//             slidesPerView: 1,
//             mousewheel: true,
//             thumbs: { swiper: Zoom$MediaThumbnailView },
//             watchOverflow: true,
//             autoHeight: true,
//             pagination: { el: '.swiper-pagination' },
//             breakpoints: { 749: { direction: 'vertical' } },
//             on: {
//               init: (swiper) => {
//                 let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                 totalGap = parseInt(totalGap + 10);
//                 document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_MainImage').style.height =
//                   totalGap + 'px';
//                 window.addEventListener('resize', () => {
//                   let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
//                   totalGap = parseInt(totalGap + 10);
//                   document.querySelector('.swiper.Zoom_slider-section__wrapper.Zoom_MainImage').style.height =
//                     totalGap + 'px';
//                 });
//               },
//             },
//           });
//         } else {
//           var Zoom$MediaMainProductView = new Swiper('.swiper.Zoom_slider-section__wrapper.Zoom_MainImage', {
//             zoom: { maxRatio: 2 },
//             slidesPerView: 1,
//             autoHeight: true,
//             pagination: { el: '.swiper-pagination' },
//           });
//         }
//         Zoom$MediaMainProductView.slideTo(CurrentPopupChoosed, 10, false);
//       });
//     });

//     document.querySelector('.CrossZoomExt').addEventListener('click', (e) => {
//       e.preventDefault();
//       document.body.classList.remove('zoomPopupActive');
//     });
//   }

//   document?.querySelectorAll('.view_all_outer').forEach((elm) => {
//     elm.children[1].querySelectorAll('a').length == 0 ? elm.classList.add('hidden') : '';
//   });
//   document.querySelector('.ProductGridCbImage')?.childElementCount == 1 &&
//   document.querySelector('.ProductGridCbImage')?.querySelectorAll('.NoWayHover').length
//     ? document.querySelector('.MainOuter__ColorCombinations').classList.add('hidden')
//     : '';

});
